import React from 'react';
import './Profile.scss';

const Profile = () => {
    return (
        <div>
            This is profile
        </div>
    );
}

export default Profile;
